import HomeLayout from "./developer_home_layout.jsx";

const HomePage = () => {
  return (
      <HomeLayout />
  );
};

export default HomePage;